"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStopsTimes = void 0;
var axios_1 = __importDefault(require("axios"));
var DIGI_TRANSIT_LAMBDA_URL = "".concat(process.env.REACT_APP_API_BASE_URL, "/contents/digitransit/stopTimes");
var STOP_TIMES_STORAGE_LIMIT = 14 * 60 * 1000; // Milliseconds
var getLocalStorageStopsTimesForWidget = function (id) {
    var stopTimesForWidget = localStorage.getItem("stopTimes_".concat(id));
    var storedStopTimes = stopTimesForWidget
        ? JSON.parse(stopTimesForWidget)
        : undefined;
    return storedStopTimes;
};
var saveStopsTimesForWidgetToLocalStorage = function (id, stops, stopTimes) {
    var storedStopTimes = {
        date: Date.now(),
        stopTimes: stopTimes,
        stops: stops
    };
    localStorage.setItem("stopTimes_".concat(id), JSON.stringify(storedStopTimes));
};
/**
 * Get stop timies for widget.
 * - Fetch new stop times only if Local Storage has too old times for the widget.
 * This prevents from unnecessary fetches in bus stop widget if playlist shows infopage only for a short time.
 */
var getStopsTimes = function (stops, numberOfDepartures, id) { return __awaiter(void 0, void 0, void 0, function () {
    var storedStopTimes_1, data, stopTimes, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                storedStopTimes_1 = getLocalStorageStopsTimesForWidget(id);
                if (storedStopTimes_1 &&
                    stops.length === storedStopTimes_1.stops.length &&
                    stops.every(function (stop) { return storedStopTimes_1.stops.find(function (s) { return s.id === stop.id; }); }) && // check that widget stops are same
                    (storedStopTimes_1 === null || storedStopTimes_1 === void 0 ? void 0 : storedStopTimes_1.date) > Date.now() - STOP_TIMES_STORAGE_LIMIT) {
                    return [2 /*return*/, storedStopTimes_1.stopTimes];
                }
                return [4 /*yield*/, axios_1.default.post(DIGI_TRANSIT_LAMBDA_URL, {
                        stops: stops,
                        startTime: Date.now(),
                        numberOfDepartures: numberOfDepartures
                    })];
            case 1:
                data = (_a.sent()).data;
                stopTimes = data.stopTimes;
                saveStopsTimesForWidgetToLocalStorage(id, stops, stopTimes);
                return [2 /*return*/, stopTimes];
            case 2:
                error_1 = _a.sent();
                // eslint-disable-next-line no-console
                console.log('getStopTimes ERROR', error_1);
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getStopsTimes = getStopsTimes;
//# sourceMappingURL=digitransit.js.map